// assets
import {
  IconTypography,
  IconPalette,
  IconShadow,
  IconWindmill,
  IconUniverse,
  IconQuestionMark,
  IconHandClick,
  IconRobot,
  IconTools,
  IconAdjustmentsSearch,
  IconSettings2,
  IconDeviceAudioTape,
  IconDeviceDesktopUp, IconFileTypeDoc, IconSpy, IconUserExclamation
} from '@tabler/icons-react';

// constant
const icons = {
  IconFileTypeDoc,
  IconSpy,
  IconUserExclamation
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const documentation = {
  id: 'documentation',
  title: 'Documentation',
  type: 'group',
  children: [
    {
      id: "terms_conditions",
      title: "Terms & Conditions",
      type: "item",
      url: "/legal/terms_conditions",
      icon: IconFileTypeDoc,
      breadcrumbs: false
    },
    {
      id: "privacy_policies",
      title: "Privacy Policies",
      type: "item",
      url: "/legal/privacy_policies",
      icon: icons.IconSpy,
      breadcrumbs: false
    },
    {
      id: "disclaimers",
      title: "Disclaimers",
      type: "item",
      url: "/legal/disclaimers",
      icon: icons.IconUserExclamation,
      breadcrumbs: false
    },
  ]
};

export default documentation;
